import { rootTermDescriptor } from 'models';
import { useFormSelector } from 'mrf/redux/ReduxHelper';
import useMRFTranslation from 'mrf/utils/useMRFTranslation';
import FormCRUD from 'mrf/view/FormCRUD';
import FormQueryObjectField from 'mrf/view/FormQueryObjectField';
import { Col, Grid } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';
import React from 'react';
import role from 'role';

export default function RootTermForm({ history, match }) {
    const t = useMRFTranslation();

    const { id } = match.params

    const context = useFormSelector({
        id: id,
        resource: 'rootTerms',
        descriptor: rootTermDescriptor
    });

    const rootTermTypeFields = [
        { name: t('Id'), key: 'id' },
        { name: t('Root Term Type Name'), key: 'termTypeName' }
    ];

    return <FormCRUD
        title='Root Term'
        match={match}
        history={history}
        context={context}
        id=''
        roleForDelete={[role.ADMIN]}
        overrideAfterPath={id ? '../..' : '../'}
    >
        <Grid>
            <Col size={4}>
                <FormQueryObjectField
                    label='Root Term Type'
                    resource='rootTermTypes'
                    endpoint={'/api/rootTermTypes'}
                    displayAttribute='termTypeName'
                    field='rootTermTypeId'
                    fields={rootTermTypeFields}
                    formEndpoint='/api/rootTermTypes'
                    disableRemove={true}
                    disableAdd
                    required
                />
            </Col>
            <Col size={8}>
                <TextField
                    label='Root Term Name'
                    field='rootTermName'
                    required
                />
            </Col>
        </Grid>
    </FormCRUD>
}